import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

// This hook checks the subscription status of the user
//it is used by the PrivateSubscriptionRoute component to check if the user has a active subscription or tailing
//
export const useSubStatus = () => {
  const [hasSubscription, setHasSubscription] = useState(null);
  const [checkingSubStatus, setCheckingSubStatus] = useState(true);
  const [subStatus, setSubStatus] = useState(null);
  const [subTier, setSubTier] = useState(null);

  const { subInfo } = useSelector((state) => state.subscription);

  useEffect(() => {
      if (!subInfo || Object.keys(subInfo).length === 0) {
          setHasSubscription(false);
      } else {
          setHasSubscription(true);
          setSubStatus(subInfo.subStatus);
          setSubTier(subInfo.subTier);
      }

      setCheckingSubStatus(false);
  }, [subInfo]);

  const canAccessFeatures = subStatus === 'trialing' || subStatus === 'active';

  return { hasSubscription, checkingSubStatus, subStatus, subTier, canAccessFeatures };
};



//lets use the subStatus from redux, 
//which can be trialing, active, past_due, cancelled, or unpaid. 
//we can abstract that in a simpler way using this hook to grant access to other features of the app, 
//